import { gql } from "@apollo/client";

export const LIST_PRODUCTS = gql`
	query products($shopId: String!, $locationId: String!) {
		products(shopId: $shopId, locationId: $locationId) {
			id
			name
			quantity
			price
			taxPercentage
			commissionPercentage
			createdAt
		}
	}
`;

export const LIST_SERVICES = gql`
	query hairservices($shopId: String!, $locationId: String!) {
		hairservices(shopId: $shopId, locationId: $locationId) {
			_id
			name
			duration_minutes
			price
			taxPercentage
			commissionPercentage
			createdAt
		}
	}
`;

export const LIST_ORDERS = gql`
	query orders($query: SearchInput!) {
		orders(query: $query) {
			_id
			sequenceNumber
			stylistUserName
			customerName
			paymentMethod
			createdAt
			total
		}
	}
`;

export const CUSTOMER_LIST = gql`
	query customerList($input: CustomerListInput!) {
		customerList(input: $input) {
			customers {
				_id
				email
				phone
				firstName
				lastName
				createdAt
			}
			total
			page
			limit
			totalPages
		}
	}
`;

export const DETELE_CUSTOMER = gql`
	mutation deleteCustomer($customerId: String!, $shopId: String!) {
		deleteCustomer(customerId: $customerId, shopId: $shopId)
	}
`;

export const DETELE_PRODUCT = gql`
	mutation deleteProduct($id: Float!) {
		deleteProduct(id: $id)
	}
`;

export const DETELE_SERVICE = gql`
	mutation deleteHairService($serviceId: String!) {
		deleteHairService(serviceId: $serviceId)
	}
`;

export const DELETE_ORDER = gql`
	mutation deleteOrder($orderId: String!) {
		deleteOrder(orderId: $orderId)
	}
`;

export const LIST_USERS = gql`
	query users($shopId: String!, $locationId: String!) {
		users(shopId: $shopId, locationId: $locationId) {
			_id
			email
			phone
			firstName
			lastName
			createdAt
		}
	}
`;

export const SEARCH_CUSTOMER_BY_PHONE = gql`
	query SearchCustomerByPhoneNumber($shopId: String!, $locationId: String!, $phone: String!) {
		searchCustomerByPhoneNumber(shopId: $shopId, locationId: $locationId, phone: $phone) {
			_id
			email
			phone
			firstName
			lastName
			createdAt
			dob
		}
	}
`;

export const DELELE_USER = gql`
	mutation deleteUser($userId: String!, $shopId: String!) {
		deleteUser(userId: $userId, shopId: $shopId)
	}
`;

export const GET_USER_BY_ID = gql`
	query User($id: String!, $shopId: String!, $locationId: String!) {
		user(userId: $id, shopId: $shopId, locationId: $locationId) {
			_id
			email
			phone
			firstName
			lastName
			shopId
			roles {
				locationId
				role
			}
		}
	}
`;

export const ADD_UPDATE_USER = gql`
	mutation AddUpdateUser($user: UserInput!) {
		addUpdateUser(user: $user) {
			_id
			firstName
			lastName
		}
	}
`;
export const GET_ORDER_BY_ID = gql`
 query Order($id: String!) {
	 order(orderId: $id) {
			_id
			sequenceNumber
			stylistUserName
			customerName
			customerId
			stylistUserId
			createdAt
			paymentMethod
			total
			products {
				name
				quantity
				price
				productId
				total
				discountValue
				discountAmount
				discountType
				stylistUserId
				stylistUserName
			}
			services {  
				name
				quantity
				price
				serviceId
				total
				discountValue
				discountAmount
				discountType
				stylistUserId
				stylistUserName
			}
	 }
 }
`;


export const ADD_UPDATE_CUSTOMER = gql`
	mutation AddUpdateCustomer($customer: CustomerInput!) {
		addUpdateCustomer(customer: $customer) {
			_id
			firstName
			lastName
		}
	}
`;

export const GET_CUSTOMER_BY_ID = gql`
	query Customer($id: String!) {
		customer(customerId: $id) {
			_id
			email
			phone
			firstName
			lastName
			dob
		}
	}
`;

export const GET_ORDERS_BY_CUSTOMER = gql`
  query OrdersByCustomer($customerId: String!) {
    ordersByCustomer(customerId: $customerId) {
      _id
      sequenceNumber
      createdAt
      total
      paymentMethod
    }
  }
`;

export const GET_USER_CURRENT_SHOP_DETAILS = gql`
	query UserDetails($userId: String!, $shopId: String!, $locationId: String!) {
		getUserCurrentShopDetails(userId: $userId, shopId: $shopId, locationId: $locationId) {
			name
			location {
				name
				phone
				address {
					street
					city
					state
					zipcode
					landmark
				}
			}
		}
	}
`;

export const LIST_EXPENSES = gql`
	query expenses($shopId: String!, $locationId: String!) {
		expenses(shopId: $shopId, locationId: $locationId) {
			_id
			name
			price
			createdAt
		}
	}
`;

export const DETELE_EXPENSE = gql`
	mutation deleteExpense($expenseId: String!) {
		deleteExpense(expenseId: $expenseId)
	}
`;

export const ADD_UPDATE_EXPENSE = gql`
	mutation addUpdateExpense($expense: ExpenseInput!) {
		addUpdateExpense(expense: $expense) {
			name
		}
	}
`;

export const GET_EXPENSE_BY_ID = gql`
	query expense($id: String!) {
		expense(_id: $id) {
			_id
			name
			price
			description
		}
	}
`;

export const GET_COMMISSION_REPORT = gql`
	query CommissionReport($query: SearchInput!) {
		commissionReport(query: $query) {
			totalStylists
			totalCommissionAmount
			totalSalesAmount
			stylistReports {
				stylistUserId
				stylistName
				totalOrders
				totalServiceAmount
				totalProductAmount
				totalAmount
				totalServiceCommission
				totalProductCommission
				totalCommission
				serviceCommissions {
					serviceId
					serviceName
					quantity
					totalAmount
					commissionPercentage
					commissionAmount
				}
				productCommissions {
					productId
					productName
					quantity
					totalAmount
					commissionPercentage
					commissionAmount
				}
			}
		}
	}
`;

export const GET_REPORT = gql`
	query report($query: SearchInput!) {
		report(query: $query) {
			totalSales
			totalProductSales
			totalServiceSales
			totalCustomers
			totalNewCustomers
			totalExistingCustomers
			orders {
				_id
				sequenceNumber
				total
				customerName
				paymentMethod
				createdAt
				services {
					total
					discountAmount
					name
					quantity
				}
				products {
					total
					discountAmount
				}
			}
			paymentReport {
				upi
				card
				cash
			}
			dailySales {
				date
				value
				label
			}
			weeklySales {
				date
				value
				label
			}
			monthlySales {
				date
				value
				label
			}
			comparisonMetrics {
				monthOverMonth
				previousPeriodSales
			}
			staffPerformance {
				userId
				userName
				totalRevenue
				serviceRevenue
				productRevenue
				orderCount
				averageOrderValue
			}
			serviceCategories {
				categoryName
				revenue
				percentage
				count
			}
			productCategories {
				categoryName
				revenue
				percentage
				count
			}
			inventoryAnalysis {
				productId
				productName
				currentStock
				quantityReserved
				quantityAvailable
				usageInPeriod
				reorderLevel
				status
				daysUntilStockout
			}
			lowStockCount
			overstockCount
		}
	}
`;

export const ADD_UPDATE_ORDER = gql`
	mutation AddUpdateOrder($order: OrderInput!) {
		addUpdateOrder(order: $order) {
			_id
			sequenceNumber
			createdAt
		}
	}
`;

export const SAVE_PRINTER_NAME = gql`
	mutation SavePrinterName($shopId: String!, $locationId: String!, $printerName: String!) {
		savePrinterName(shopId: $shopId, locationId: $locationId, printerName: $printerName) 
	}
`;

export const GET_PRINTER_NAME = gql`
	query GetPrinterName($shopId: String!, $locationId: String!) {
		printerName(shopId: $shopId, locationId: $locationId)
	}
`;

export const QUEUE_BILL_TO_WHATSAPP = gql`
	mutation QueueBillToWhatsApp($orderId: String!, $message: String) {
		queueBillToWhatsApp(orderId: $orderId, message: $message)
	}
`;

export const GET_MESSAGING_QUEUE_STATS = gql`
	mutation GetMessagingQueueStats($shopId: String) {
		getMessagingQueueStats(shopId: $shopId)
	}
`;

// ============================================
// SHOP MANAGEMENT (Root Admin)
// ============================================

export const LIST_ALL_SHOPS = gql`
	query ListAllShops($includeDeleted: Boolean) {
		shops(includeDeleted: $includeDeleted) {
			_id
			name
			location {
				_id
				name
				address {
					city
					street
					state
					zipcode
				}
				email
				phone
				businessType
			}
			createdAt
			updatedAt
			deletedAt
		}
	}
`;

export const CREATE_SHOP = gql`
	mutation CreateShop($shop: ShopInput!) {
		addShop(shop: $shop) {
			_id
			name
			createdAt
		}
	}
`;

export const UPDATE_SHOP = gql`
	mutation UpdateShop($shopId: String!, $shop: ShopInput!) {
		updateShop(shopId: $shopId, shop: $shop) {
			_id
			name
			updatedAt
		}
	}
`;

export const TOGGLE_SHOP_STATUS = gql`
	mutation ToggleShopStatus($shopId: String!) {
		toggleShopStatus(shopId: $shopId)
	}
`;

// ============================================
// LOCATION MANAGEMENT (Shop Admin)
// ============================================

export const CREATE_LOCATION = gql`
	mutation CreateLocation($shop: ShopInput!) {
		addLocationToShop(shop: $shop) {
			_id
			name
			location {
				_id
				name
				address {
					city
				}
				businessType
			}
		}
	}
`;

export const UPDATE_LOCATION = gql`
	mutation UpdateLocation($shopId: String!, $locationId: String!, $location: ShopInput!) {
		updateLocation(shopId: $shopId, locationId: $locationId, location: $location) {
			_id
			name
			location {
				_id
				name
				address {
					city
					street
					state
					zipcode
				}
				businessType
			}
		}
	}
`;

export const DELETE_LOCATION = gql`
	mutation DeleteLocation($shopId: String!, $locationId: String!) {
		deleteLocation(shopId: $shopId, locationId: $locationId)
	}
`;

// ============================================
// USER IMPERSONATION (Super Admin)
// ============================================

export const IMPERSONATE_USER = gql`
	mutation ImpersonateUser($phoneNumber: String!) {
		impersonateUser(phoneNumber: $phoneNumber)
	}
`;

export const EXIT_IMPERSONATION = gql`
	mutation ExitImpersonation {
		exitImpersonation
	}
`;

// ============================================
// USER EVENTS
// ============================================

export const GET_USER_EVENTS = gql`
	query UserEvents($input: GetUserEventsInput!) {
		userEvents(input: $input) {
			events {
				_id
				userId
				userName
				eventType
				shopId
				shopName
				locationId
				locationName
				referenceId
				details
				ipAddress
				createdAt
			}
			total
			page
			limit
			totalPages
		}
	}
`;
// ============================================
// DELIVERY LOCATION SETTINGS
// ============================================

export const DELIVERY_LOCATION_CONFIG = gql`
	query DeliveryLocationConfig($locationId: String!) {
		deliveryLocationConfig(locationId: $locationId) {
			id
			locationId
			shopId
			latitude
			longitude
			deliveryRadiusKm
			baseFee
			perKmRate
			minFee
			driverPerKmRate
			fleetModel
			isDeliveryEnabled
			acceptsCashOnDelivery
			paymentConnection {
				provider
				status
				razorpayAccountId
				connectedAt
				statusReason
			}
			updatedAt
		}
	}
`;

export const DELIVERY_LOCATIONS_FOR_SHOP = gql`
	query DeliveryLocationsForShop($shopId: String!) {
		deliveryLocationsForShop(shopId: $shopId) {
			id
			locationId
			deliveryRadiusKm
			isDeliveryEnabled
			acceptsCashOnDelivery
			paymentConnection {
				status
			}
		}
	}
`;

export const CONFIGURE_DELIVERY_LOCATION = gql`
	mutation ConfigureDeliveryLocation($input: DeliveryLocationConfigInput!) {
		configureDeliveryLocation(input: $input) {
			id
			locationId
			latitude
			longitude
			deliveryRadiusKm
			baseFee
			perKmRate
			minFee
			driverPerKmRate
			fleetModel
			isDeliveryEnabled
			acceptsCashOnDelivery
		}
	}
`;

/** Returns the Razorpay authorisation URL to open. Valid for 15 minutes. */
export const START_RAZORPAY_CONNECT = gql`
	mutation StartRazorpayConnect($locationId: String!) {
		startRazorpayConnect(locationId: $locationId)
	}
`;

export const DISCONNECT_RAZORPAY = gql`
	mutation DisconnectRazorpay($locationId: String!) {
		disconnectRazorpay(locationId: $locationId) {
			id
			locationId
			paymentConnection {
				status
			}
		}
	}
`;

export const SET_DELIVERY_LOCATION_ENABLED = gql`
	mutation SetDeliveryLocationEnabled($locationId: String!, $enabled: Boolean!) {
		setDeliveryLocationEnabled(locationId: $locationId, enabled: $enabled) {
			id
			locationId
			isDeliveryEnabled
		}
	}
`;
